import React from "react";

// html editor
import HTMLEditor from 'utlis/helpers/HTMLEditor'

export default function AppFormHTMLFieldInline(props) {
    const {
        formik,
        stFormClass,
        labelName,
        isRequired,
        formikFieldName,
        getResult
    } = props;

    return (
        <div
            className={`st-form ${stFormClass || ""} ${formik.touched[formikFieldName] &&
                formik.errors[formikFieldName]
                ? "has-msg msg-error"
                : ""
                }`}
        >
            {labelName ? (
                <label>
                    {labelName}
                    {isRequired && <span className="required ms-1 st-fs-12">(required)</span>}
                </label>
            ) : null}
            <div className="media-body">
                <HTMLEditor
                    defaultValue={formik.values[formikFieldName]}
                    getResult={getResult}
                />
                {
                    /* form message */
                    formik.touched[formikFieldName] &&
                    formik.errors[formikFieldName] && (
                        <div className="st-form-msg position-absolute" style={{ bottom: -18 }}>
                            <p className="st-fs-12">
                                {formik.errors[formikFieldName]}
                            </p>
                        </div>
                    )
                }
            </div>
        </div>
    );
}
